import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  actions?: ReactNode;
}

/** Titre de page ; sur téléphone, les actions passent sous le titre et prennent toute la largeur. */
export default function PageHeader({ title, subtitle, icon, actions }: PageHeaderProps) {
  return (
    <div className="mb-5 flex flex-col gap-4 sm:mb-6 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex min-w-0 items-center gap-3">
        {icon && (
          <span className="hidden w-11 h-11 shrink-0 rounded-lg bg-primary-600 text-white shadow-raised items-center justify-center sm:flex" aria-hidden="true">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div className="min-w-0">
          <h1 className="text-xl font-semibold font-heading text-foreground-950 sm:text-2xl break-words">{title}</h1>
          {subtitle && <p className="text-sm text-foreground-500 mt-0.5 break-words">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 [&>*]:flex-1 sm:[&>*]:flex-none">{actions}</div>}
    </div>
  );
}
